import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";

const PrintGISFinal = () => {
  const navigate = useNavigate();
  const route = useParams().id;
  const userId = localStorage.getItem("userId");
  const [PensionProposalData, setPensionProposalData] = useState([]);
  const getPensionProposalData = async () => {
    try {
      const response = await fetch(
        `${api_url}/api/users/get-pension_proposal-data`,
        {
          method: "POST",
          body: JSON.stringify({
            userId,
          }),
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        }
      );
      const result = await response.json();
      if (result.status === 201) {
        let singleData = result.result.find((item) => item._id === route);

        setPensionProposalData(singleData);
      } else {
        setPensionProposalData([]);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getPensionProposalData();
  }, [userId]);
  const [formData, setFormData] = useState([]);
  const [familyMember, setfamilyMember] = useState([]);
  useEffect(() => {
    try {
      if (PensionProposalData?.formData) {
        setFormData(JSON.parse(PensionProposalData.formData));
      }
      if (PensionProposalData?.familyMember) {
        setfamilyMember(JSON.parse(PensionProposalData.familyMember));
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
    }
  }, [PensionProposalData]);

  const [serviceDurationYears, ServiceDurationYears] = useState(0);
  const [serviceDurationMonth, setServiceDurationMonth] = useState(0);
  // Update the home rent whenever formData changes
  useEffect(() => {
    // Function to extract years (वर्ष) as a string
    const getYears = (text) => {
      if (text) {
        const parts = text.split(","); // Split by commas
        const yearsPart = parts.find((part) => part.includes("वर्ष")); // Find the part with "वर्ष"

        if (yearsPart) {
          // Extract the number before "वर्ष" using regex
          const match = yearsPart.match(/\d+/); // Match numeric digits
          return match ? parseInt(match[0], 10) : null; // Return the number or null
        }
      }

      return null; // Return null if "वर्ष" is not found
    };
    const getMonths = (text) => {
      if (text) {
        const parts = text.split(","); // Split by commas
        const monthsPart = parts.find((part) => part.includes("महिने")); // Find the part with "महिने"

        if (monthsPart) {
          // Extract the number before "महिने" using regex
          const match = monthsPart.match(/\d+/); // Match numeric digits
          return match ? parseInt(match[0], 10) : null; // Return the number or null
        }

        return null; // Return null if "महिने" is not found
      }
    };

    // Example usage:
    const months = getMonths(formData && formData.serviceDuration);

    const years = getYears(formData && formData.serviceDuration);
    setServiceDurationMonth(
      months >= 3 && months < 9 ? 1 : months >= 9 && months < 12 ? 2 : 0
    );

    const result = getYears(formData.serviceDuration);
    ServiceDurationYears(result); // Output: "4 वर्ष"
  }, [formData.serviceDuration]);

  const [serviceDurationMonth1, setServiceDurationMonth1] = useState(0);

  useEffect(() => {
    setServiceDurationMonth1(
      serviceDurationYears > 33
        ? Math.round(33 * 2)
        : Math.round(serviceDurationYears * 2 + serviceDurationMonth)
    );
  }, [
    formData.birthDateNumber,
    formData.appointmentDate,
    formData.retirementDate,
    serviceDurationYears,
    serviceDurationMonth,
  ]);

  const generatePrintablePage = async () => {
    // Add dynamic CSS for proper page breaks and consistent layout
    const style = document.createElement("style");
    style.innerHTML = `
            /* General styling */
            * {
              padding: 0px !important;
              margin: 0px !important;
              font-size: 14px !important;
              color: #000 !important;
              box-sizing: border-box; /* Maintain consistent sizing */
            }
            .commonClassTable{
              margin: 0px 0 !important;
              width:100% !important;
            }
            #gis-final-print {
              width: 100%;
            }
            table th,table td{
              padding: 2px 5px !important;
            }
              
            /* Ensure each section prints on its own page */
            #gis-final-print > div {
              page-break-after: always; /* Force each child div to print on a new page */
              page-break-inside: avoid; /* Avoid breaking inside sections */
            }
            
      
            /* Page setup */
            @page {
              size: A4; /* Set the page size to A4 */
              margin: 10mm 10mm 10mm 10mm !important; /* Set page margin */
            }
        
            @media print {
              body {
                margin: 0;
                padding: 0;
              }
        
              /* Hide unnecessary sections like buttons */
              #button-section {
                display: none;
              }
            }
          `;
    document.head.appendChild(style);

    // Get the #inter-district-transfer-print element
    const printContent = document.getElementById("gis-final-print");

    if (printContent) {
      // Clone the content for printing
      const printWrapper = document.createElement("div");
      printWrapper.id = "print-wrapper";

      // Clone each child element of #inter-district-transfer-print
      Array.from(printContent.children).forEach((child) => {
        const clone = child.cloneNode(true);
        printWrapper.appendChild(clone);
      });

      // Append the cloned content to the body
      document.body.appendChild(printWrapper);

      // Trigger the print dialog
      window.print();

      // Clean up after printing
      document.body.removeChild(printWrapper);
      document.head.removeChild(style);
    } else {
      alert("No content available for printing.");
    }
  };

  return (
    <div className="container-xl py-3">
      <div className="row my-4" id="button-section">
        <div className="col-lg-4">
          <button
            className="btn btn-primary"
            onClick={() => navigate("/dashboard/pension_proposal")}
          >
            Back
          </button>
        </div>
      </div>
      <div id="gis-final-print" className="gis-final-print mt-3">
        <div id="section1" className="commonClassTable border px-5 py-5">
          <div className="row mt-2">
            <div className="col-lg-7 col-md-7 col-7"></div>
            <div className="col-lg-5 col-md-5 ms-auto col-5">
              <p className="fw-bold">
                {formData && formData.officeSerialNumber}
              </p>
              <p className="fw-bold">{formData && formData.officeName}</p>
              <p className="fw-bold ">दिनांक :</p>
            </div>
          </div>

          <p className="fw-bold mt-1">प्रति,</p>
          <p className="fw-bold mt-1"> जिल्हा आरोग्य अधिकारी</p>
          <p className="fw-bold mt-1">{formData && formData.currentDistrict}</p>

          <p className="text-left mt-3">
            प्रकरण :- गटविमा रक्कम परत मिळणेबाबतचा प्रस्ताव सादर करणेबाबत,
          </p>
          <p className="textIndent text-left mt-3">
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>
          </p>
          <p className="fw-bold text-left mt-2">
            Sevarth ID : {formData && formData.sevarthID}
          </p>
          <p className="mt-3">महोदय,</p>
          <p class="textIndent">
            वरिल विषयाच्या अनुषंगाने सविनय सादर करण्यात येते की-{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            हे दि. <b>{formData && formData.retirementDate}</b> रोजी{" "}
            {formData && formData.retirementType}नुसार सेवानिवृत्त झालेले आहेत.
            त्यांचा गटविमा प्रस्ताव रक्कम मिळणेबाबत पुढील कार्यवाहीस्तव सादर
            करण्यात येत आहे.
          </p>
          <p class="textIndent">कृपया स्वीकार व्हावा ही विनंती.</p>
          <p className="fw-bold mt-3">सोबत -</p>
          <p class="textIndent mb-2">
            १ विहित नमुण्यातील गटविमा प्रस्ताव ४ प्रति.
          </p>
          <p class="textIndent mb-2">
            २{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
            </b>{" "}
            यांची मूळसेवापरितका.
          </p>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              {/* <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p> */}
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
        </div>

        <div id="section2" className="commonClassTable border px-5 py-5">
          <div className="row mt-2">
            <div className="col-lg-7 col-md-7 col-7"></div>
            <div className="col-lg-5 col-md-5 ms-auto col-5">
              <p className="fw-bold">
                {formData && formData.officeSerialNumber}
              </p>
              <p className="fw-bold">{formData && formData.officeName}</p>
              <p className="fw-bold ">दिनांक :</p>
            </div>
          </div>

          <p className="fw-bold mt-1">प्रति,</p>
          <p className="fw-bold mt-1"> मा. मुख्यलेखा व वित्त अधिकारी,</p>
          <p className="fw-bold mt-1">{formData && formData.currentDistrict}</p>

          <p className="text-left mt-3">
            प्रकरण :- गटविमा रक्कम परत मिळणेबाबत,
          </p>
          <p className="textIndent text-left mt-3">
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>
          </p>
          <p className="fw-bold text-left mt-2">
            Sevarth ID : {formData && formData.sevarthID}
          </p>
          <p className="mt-3">महोदय,</p>
          <p class="textIndent">
            वरिल संदर्भिय विषयाच्या अनुषंगाने सादर करण्यात येते की.{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            हे दि. <b>{formData && formData.retirementDate}</b> रोजी{" "}
            {formData && formData.retirementType}नुसार सेवानिवृत्त झालेले आहेत.
            त्यांचा गटविमा प्रस्ताव रक्कम मिळणेबाबत पुढील कार्यवाहीस्तव सादर
            करण्यात येत आहे.
          </p>
          <p class="textIndent">
            कृपया स्वीकार व्हावा व योग्य ती कार्यवाही करावी हि विनंती.
          </p>
          <p className="fw-bold mt-3">सोबत -</p>
          <p class="textIndent mb-2">
            १ विहित नमुण्यातील गटविमा प्रस्ताव ३ प्रति.
          </p>
          <p class="textIndent mb-2">
            २{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
            </b>{" "}
            यांची मूळसेवापरितका.
          </p>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              {/* <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p> */}
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.hodDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.currentDistrict}
              </p>
            </div>
          </div>
        </div>

        <div id="section3" className="commonClassTable py-2">
          <h3 className="fw-bold text-2xl text-center mb-3">
            गटविमा योजनेची चेकलिस्ट
          </h3>
          <div className="px-3">
            <table className="table table-borderless border-0 w-75">
              <tbody>
                <tr>
                  <td>१</td>
                  <td>कर्मचा-याचे पूर्ण नाव</td>
                  <td>:-</td>
                  <th>
                    {formData && formData.fullName},
                    {formData && formData.designation}
                  </th>
                </tr>
                <tr>
                  <td>२</td>
                  <td> कार्यालयाचे नाव </td>
                  <td>:-</td>
                  <th>{formData && formData.officeName}</th>
                </tr>
                <tr>
                  <td>३</td>
                  <td> प्रथम नेमणूक दिनांक </td>
                  <td>:-</td>
                  <td>{formData && formData.appointmentDate}</td>
                </tr>
                <tr>
                  <td>४</td>
                  <td> जन्मदिनांक </td>
                  <td>:-</td>
                  <td>{formData && formData.birtdDateNumber}</td>
                </tr>
                <tr>
                  <td>५</td>
                  <td> सेवानिवृत्त दिनांक</td>
                  <td>:-</td>
                  <td>{formData && formData.retirementDate}</td>
                </tr>
                <tr>
                  <td>६</td>
                  <td> गटविमा योजनेचे सदस्य झाल्याचा दिनांक</td>
                  <td>:-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered mt-2">
              <tbody>
                <tr>
                  <th>अक्र</th>
                  <th className="text-center">
                    प्रस्तावाच्या छाननी बाबत तपशील
                  </th>
                  <th>अभिप्राय</th>
                </tr>
                <tr>
                  <th>१</th>
                  <td>
                    गटविमा योजनचे सदस्य असल्याची नोंद दिनांक 1-10-1990 घेतली आहे
                    काय ?
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>२</th>
                  <td>
                    पदोन्नती किवा कालबद्ध पदोन्नती वेतनश्रेणी मिळाल्यानुसार गट
                    विमा वर्गणी वसुली केली आहे काय व त्याबाबतची नोंद मूळ सेवा
                    पुस्तकेत घेण्यात आलेली आहे काय ?
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>३</th>
                  <td>
                    सुधारित गटविमा योजनेच्या वर्गणीत वाढ झालेली असल्यारा
                    त्याबाबतची नोंद घेण्यात आली आहे काय ?
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>४</th>
                  <td>
                    सुधारत गट विमा योजनेच्या वर्गणीचीचे समायोजन केले आहे काय
                    त्याबाबतची नोंद घेण्यात आली आहे काय ?
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th rowSpan={2}>५</th>
                  <td>
                    वेतन आयोगानुसार मिळालेल्या वेतनश्रेणीची नोंद तसेच वर्गणीत
                    वाढ झाल्याबाबत वर्गणीत वाढ झालेली असल्यारा त्याबाबतची नोंद
                    घेण्यात आली आहे काय ?
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    गट विमा प्रस्तावातील सुधारित प्रपत्र ८ परिपूर्ण भरण्यात
                    आलेले आहे काय
                  </td>
                  <td></td>
                </tr>

                <tr>
                  <th>६</th>
                  <td>
                    गट विमा योजनेमधून गृहकर्जाची नोंद सेवा पुस्तिकेत घेतली आहे
                    काय
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>७</th>
                  <td>
                    मूळ सवा पुरितकेतमध्ये सेवानिवृत्त / राजीनामा / मयत इत्यादी
                    बाबतची नोंद घेतली आहे काय
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>८</th>
                  <td>
                    मयत असल्यास मृत्यु प्रमापत्र नॉमिनेशन किंवा न्यायालयाचे वारस
                    हक्क प्रमाापत्र इ. प्रमाणित करुन सादर केले आहे काय
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>९</th>
                  <td>
                    आदेश प्रारुप संपूर्ण नांव निळ्या शाईने स्पष्ट अक्षरात भरुन
                    जोडले आहे काय
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>१०</th>
                  <td>
                    गट विमा वर्गणीचा कपातीचा कालावधी अचूक दर्शविला आहे काय
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>११</th>
                  <td>गट विमा योजनेचा प्रस्ताव तीन प्रतीत आहे काय</td>
                  <td></td>
                </tr>
                <tr>
                  <th>१२</th>
                  <td>
                    मयत असल्यास गट विमा योजनेचे बचत व विमा तीन प्रमाणपत्र एकूण ६
                    प्रस्ताव सादर केले आहे काय
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>१३</th>
                  <td>
                    विभाग प्रमुख यांनी गट विमा योजनेचे संचिकेत मयत
                    कर्मचा-यांच्या लाभधारकाचा नावासहीत सादर केले आहे काय
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>१४</th>
                  <td>
                    मयत कर्मचाऱ्याच्या बाबतीत आपलया अधिनिस्त कार्यालयाकडून
                    संबंधित वारसदार यांचे हमीपत्र घेतले आहे काय
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>१५</th>
                  <td>
                    गट विमा योजनेचे सदस्य झाल्याच्या तारखेच्या दिवशी नॉमिनेशन
                    फॉर्म भरुन दिला आहे काय
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <th>१६</th>
                  <td>कायमच्या पत्त्याची नोद प्रस्तावात घेतली आहे काय</td>
                  <td></td>
                </tr>
                <tr>
                  <th>१७</th>
                  <td>
                    शासनाने वेळोवेळी दिलेल्या शासन निर्णयातील सुचनेनुसार
                    प्रस्तावातील गट विमा योजनेच्या रकमेचे प्रस्ताव सादर केले आहे
                    काय
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <p class="textIndent mt-2">
              प्रमाणित करण्यात येते की.{" "}
              <b>
                {formData && formData.fullName},
                {formData && formData.designation},{" "}
                {formData && formData.officeName}
              </b>{" "}
              यांची उपरोक्त दर्शविण्यात आलेली माहिती तपासली असून ती बरोबर आहे.
              याची खात्री करण्यात येत आहे.
            </p>
            <div className="row mt-5 align-items-center">
              <div className="col-lg-8 col-8 col-md-8">
                {/* <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p> */}
              </div>

              <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
                <p className="fw-bold mt-3 text-center">
                  {formData && formData.officerDesignation}
                </p>
                <p className="fw-bold mt-1 text-center">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
            <p className="mt-3">
              टिप:- गटविमा योजनेच्या नोटी रक्कम व प्रमाणक क्रमांकासह नोंदवाव्या
            </p>
          </div>
        </div>

        <div id="section4" className="commonClassTable border px-5 py-5">
          <div className="row mt-2">
            <div className="col-lg-8 col-md-8"></div>
            <div className="col-lg-4 col-md-4 ms-auto">
              <p class="fw-bold">गट विमा योजना १९८२</p>
              <p class="fw-bold">प्रपत्र क्र (३)</p>
              <p class="fw-bold">परिच्छेद १५(२)</p>
              <p className="fw-bold mt-2">दिनांक :</p>
            </div>
          </div>

          <p className="fw-bold mt-3">प्रति,</p>
          <p className="fw-bold mt-1"> मा. मुख्यलेखा व वित्त अधिकारी,</p>
          <p className="fw-bold mt-1">{formData && formData.currentDistrict}</p>

          <p className="text-left mt-3">
            विषय :- राज्य शासकिय कर्मचारी गट विमा योजना १९८२ खालील शासकिय
            कर्मचारी यांना संचित मिळण्या बाबतचा अर्ज,
          </p>
          <p className="textIndent text-left mt-2">
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>
          </p>
          <p className="mt-3">महोदय,</p>
          <p class="textIndent">
            मी{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            दि. <b>{formData && formData.appointmentDate}</b> पासून जिल्हा परिषद
            कर्मचारी गटविमा योजना ५/५/१९९० प्रमाणे सदस्य आहे. मी दिनांक
            <b>{formData && formData.retirementDate}</b> पासून{" "}
            {formData && formData.retirementType} झालो आहे. जिल्हा परिषद सेवेत
            नाही किंवा निवृत्तीपूर्व जिल्हा परिषदेची सेवा सोडण्यापूर्वी मी{" "}
            <b>{formData && formData.designation}</b> हे पद धारण केलेले होते.
            शासनाने जिल्हा परिषद कर्मचा-यांना लागू केलेल्या गटविमा योजनेखालील
            मला मिळू शकणारी रक्कम मला देण्यात यावी अशी मी विनंती करते
          </p>
          <p className="fw-bold mt-3">सोबत -</p>
          <p class="textIndent mb-2">
            १ विहित नमुण्यातील गटविमा प्रस्ताव ३ प्रति.
          </p>
          <p class="textIndent mb-2">
            २{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
            </b>{" "}
            यांची मूळसेवापरितका.
          </p>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              {/* <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p> */}
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.fullName},
                {formData && formData.designation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
        </div>

        <div id="section5" className="commonClassTable border px-3 py-5">
          <h3 className="fw-bold text-2xl text-center mb-1">
            गटविमा योजना-नमुना ८
          </h3>
          <h3 className="fw-bold text-2xl text-center mb-1">
            पावती नोंदलेले बिल
          </h3>
          <p class=" text-center">
            जिल्हा परिषद कर्मचा-याना लागू केलेली राज्य शासकिय कर्मचा-याची गटविमा
            योजना १९८२ अन्वये
          </p>
          <p className="textIndent mt-3">
            कर्मचा-याचे नाव :-{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
            </b>
          </p>
          <p className="textIndent ">
            कार्यालयाचे नाव :- <b>{formData && formData.officeName}</b>
          </p>
          <p class="ps-5 mt-3">
            वर्ग-३ व वर्ग ४ यांच्या खाती जमा अगलेल्या विमा निधीमधून / आणि /
            किंवा बचत निधी मधून मिळण्याचा हकक असलेली एकूण रक्कम रूपये
            ___________________ _________________________________ मिळाली.
          </p>
          <p className="textIndent ">दिनांक</p>
          <div className="row  align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              {/* <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p> */}
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-2">
              <textarea
                rows={3}
                cols={25}
                className="border-1 border-black bg-white"
                readOnly
              ></textarea>
              <p className=" text-center">रक्कम घेणा-याची राही व नाव</p>
              <p className="fw-bold text-center">
                {formData && formData.fullName},
                {formData && formData.designation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
          <p className="textIndent ">वर्गीकरण ---</p>
          <p class="textIndent ps-4">८०११- विमा व निवृत्ती वेतन निधी.</p>
          <p class="textIndent ps-4">१०७-इतर विमा व निवृत्ती वेतन निधी.</p>
          <p class="textIndent ps-4">२-जिल्हा परिषद कर्मचा-याची गटविमा योजना</p>
          <p class="textIndent ps-4">अ.</p>
          <p class="textIndent ps-4">ब.</p>
          <p class="textIndent ps-4">आहरण व संवितरण अधिका-याने वापरण्यासावी</p>
          <p class="textIndent ps-3">
            ए] आहरण व संवितरण अधिका-याने पुरवण्याची सुसंबद्ध व्यक्तिगत माहिती -
          </p>
          <p class="textIndent ps-4">
            १. सदस्याचा र्वा प्रकार ___र्वा प्रकार (म्हाजे धम्तमाट) म्हाजे १९
            मध्ये योजनेत सहभागी होण्याच्या वेळचा वर्ग.
          </p>
          <p class="textIndent ps-4">
            २. वरच्या वर्गाचे सदस्यत्व मिळण्याचे वर्ष- तीन-१९
          </p>
          <div className="container ps-4">
            <p class="textIndent ps-4">2.</p>
            <p class="textIndent ps-4">३. एक-१९</p>
          </div>
          <p class="textIndent mt-2">
            मागणीदाराला रूपये __________________________ (अक्षरी रुपये
            ________________________________________________________)
          </p>
          <p class="textIndent ">
            च्या प्रदानासाठी मागणीदाराच्या नावे धनाकर्ष देण्यात यावा.
          </p>

          <div className="row  align-items-center">
            <div className="col-lg-7 col-7 col-md-7">
              {/* <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p> */}
            </div>

            <div className="col-lg-5 col-5 col-md-5 mt-2">
              <p class="text-start mx-4">सही -</p>
              <p class="text-start mx-4">दिनांक-</p>
              <p class="text-start mx-4">आहरण व संवितरण अधिका-याची स्वाक्षरी</p>
            </div>
          </div>
          <p class="ps-5 mt-2">
            अधिदान व लेखाअधिका-यांच्या कोषागार अधिका-याच्या कार्यालयात वापरासाठी
            __________________________________________________________ यांच्या
            मार्फत रू____________________________________ (अक्षरी रू
            __________________________________________________) च्या प्रदानासाठी
            पारा केले
          </p>
          <p class="textIndent mt-2">
            चक क्रमांक ________________________________
          </p>
          <p class="textIndent">दिनांक</p>

          <div className="row  align-items-center">
            <div className="col-lg-7 col-7 col-md-7"></div>

            <div className="col-lg-5 col-5 col-md-5 mt-2">
              <p class="text-start mx-4">अभिदान व लेखा कोषागार अधिकारी</p>
            </div>
          </div>
          <div class="container">
            <p class="text-end mx-4"></p>
          </div>
        </div>

        <div id="section6" className="commonClassTable border px-5 py-5">
          <h3 className="fw-bold text-2xl text-center mb-1">प्रमाणपत्र</h3>
          <p className="textIndent mt-3">
            प्रमाणित करण्यात येते की वरील अनुक्रमांक २ मध्ये नमूद केलेल्या शासन
            परिपत्रक दिनांक ३०/०४/१९८२ मधील परिच्छेद अ १ व अ ३ वरील शासन
            परिपत्रक दिनांक २१/०९/१९८२ मधील ती ( अ ) तरतुदीनुसार{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            यांच्या सेवा पुस्तकेतील गट विमा योजनेच्या सदस्यत्व विषयी नामनिर्देशन
            पत्र घेतल्याची व गटविकास योजनेखालील लाभ प्रदानचा आदेश क्रमांक व
            दिनांक यांची आवश्यक नोंद घेतली आहे
          </p>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p>
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
          <p style={{ borderBottom: "3px solid #000", margin: "30px 0" }}></p>
          <h3 className="fw-bold text-2xl text-center mb-1">प्रमाणपत्र</h3>

          <p className="textIndent mt-3">
            प्रमाणित करण्यात येते की, शासन निर्णय वित्त विभाग क्रमांक गवियोजना
            /१९८३/प्रक्र ६६/८४/प्रशासन-५ दिनांक २८ फेबुवारी १९८६ मधील उपपरिच्छेद
            दोन ब मध्ये विहित केलेल्या सदस्यात्वाची नोंदवही नमुना क्र.८ मध्ये{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            यांच्या बाबतीत गट विमा योजनेचे सदस्य नामनिर्देशन पत्र योजनेखालील लाभ
            प्रदानचा आदेश क्रमांक व दिनांक यांची आवश्यक नोंद घेतली आहे
          </p>

          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p>
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
          <p style={{ borderBottom: "3px solid #000", margin: "30px 0" }}></p>
          <h3 className="fw-bold text-2xl text-center mb-1">नमुना स्वाक्षरी</h3>

          <p className="textIndent mt-3">
            प्रमाणित करण्यात येते की{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            यांचे नमुना स्वाक्षरी खालील प्रमाणे आहेत व माझ्या समक्ष
            स्वाक्षरी केली आहे
          </p>
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-3 col-3 col-md-3 text-center">
              {" "}
              <textarea
                rows={3}
                cols={25}
                className="border-1 border-black bg-white"
                readOnly
              ></textarea>
            </div>
            <div className="col-lg-3 col-3 col-md-3 text-center">
              {" "}
              <textarea
                rows={3}
                cols={25}
                className="border-1 border-black bg-white"
                readOnly
              ></textarea>
            </div>
            <div className="col-lg-3 col-3 col-md-3 text-center">
              {" "}
              <textarea
                rows={3}
                cols={25}
                className="border-1 border-black bg-white"
                readOnly
              ></textarea>
            </div>
          </div>

          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8"></div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
        </div>

        <div id="section7" className="commonClassTable border px-5 py-5">
          <h3 className="fw-bold text-2xl text-center mb-1">प्रमाणपत्र</h3>
          <p className="textIndent mt-3">
            प्रमाणित करण्यात येते की{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            हे गटविमा योजनेचे ___________________ पासून सदस्य आहेत. त्याचा
            गटविमा वर्गणी खालीलप्रमाणे कपात करण्यात आली आहे
          </p>
          <table class="table table-bordered text-center">
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>कार्याचा कालावधी</th>
                <th>कामा कराराचा अंदाजे कामाचा दर</th>
                <th>विक्रम प्रमाणक क्रमांक</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>१</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>२</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>३</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>४</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <p>करिता प्रमाणपत्र देण्यात येत आहे.</p>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8"></div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
          <p style={{ borderBottom: "3px solid #000", margin: "30px 0" }}></p>
          <h3 className="fw-bold text-2xl text-center mb-1">प्रमाणपत्र</h3>
          <p className="textIndent mt-3">
            प्रमाणित करण्यात येते की{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            पांनी गटविमा योजनेअंतर्गत कोणत्याही शासनमान्य गृहसंस्थेकडून गृह कर्ज
            घेतलेले नाही.
          </p>
          <p className="textIndent mt-2">करिता प्रमाणपत्र देण्यात येत आहे.</p>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8"></div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
          <p style={{ borderBottom: "3px solid #000", margin: "30px 0" }}></p>
          <h3 className="fw-bold text-2xl text-center mb-1">प्रमाणपत्र</h3>
          <p className="textIndent mt-3">
            प्रमाणित करण्यात येते की{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            यांचा कायमचा पत्ता खालील प्रमाणे आहे.
          </p>
          <p className="textIndent mt-3">
            नाव:-{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
          </p>
          <p className="textIndent mt-3">
            पत्ता:- <b>{formData && formData.address}</b>{" "}
          </p>
          <p className="textIndent mt-2">करिता प्रमाणपत्र देण्यात येत आहे.</p>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8"></div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
        </div>

        <div id="section8" className="commonClassTable border px-5 py-5">
          <h3 className="fw-bold text-2xl text-center mb-1">
            सुधारित पप्रत्र (8)
          </h3>
          <h3 className="fw-bold text-xl text-center mb-1">
            शासकीय कर्मचारी गट विमा योजना १९८२ जिल्हा परिषद कर्मचारी यांना लागू
            करणे बाबत सदस्य नोंदवही परिच्छेद १८
          </h3>
          <table class="table table-bordered text-center">
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>नाव</th>
                <th>पदनाम</th>
                <th>जन्मदिनांक</th>
                <th>नियुक्तीचा दिनांक</th>
                <th>
                  <small>वर्गणी भरण्यास सुरुवात केल्याचा दिनांक</small>
                </th>
                <th>
                  <small>
                    वरच्या वर्गात बढती झाल्याचा / दुसऱ्या विभागात बदली झाल्याचा
                    दिनांक
                  </small>
                </th>
                <th>
                  <small>
                    सदस्यत्व संपुष्टात येण्याचा दिनांक व त्याचे कारण
                  </small>
                </th>
                <th>मृत्यूचा दिनांक</th>
                <th>नामनिर्देशन पत्राचा तपशील</th>
                <th>प्रदानाचा तपशील</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>१</td>
                <td
                  style={{
                    transform: "rotate(180deg)",
                    writingMode: "vertical-rl",
                  }}
                >
                  {" "}
                  {formData && formData.fullName}
                </td>
                <td
                  style={{
                    transform: "rotate(180deg)",
                    writingMode: "vertical-rl",
                  }}
                >
                  {" "}
                  {formData && formData.designation}
                </td>
                <td
                  style={{
                    transform: "rotate(180deg)",
                    writingMode: "vertical-rl",
                  }}
                >
                  {" "}
                  {formData && formData.birtdDateNumber}
                </td>
                <td
                  style={{
                    transform: "rotate(180deg)",
                    writingMode: "vertical-rl",
                  }}
                >
                  {" "}
                  {formData && formData.appointmentDate}
                </td>
                <td
                  style={{
                    transform: "rotate(180deg)",
                    writingMode: "vertical-rl",
                  }}
                >
                  {" "}
                </td>
                <td
                  style={{
                    transform: "rotate(180deg)",
                    writingMode: "vertical-rl",
                  }}
                >
                  {" "}
                </td>
                <td
                  style={{
                    transform: "rotate(180deg)",
                    writingMode: "vertical-rl",
                  }}
                >
                  {" "}
                </td>
                <td
                  style={{
                    transform: "rotate(180deg)",
                    writingMode: "vertical-rl",
                  }}
                >
                  {" "}
                </td>
                <td
                  style={{
                    transform: "rotate(180deg)",
                    writingMode: "vertical-rl",
                  }}
                >
                  {" "}
                </td>
                <td
                  style={{
                    transform: "rotate(180deg)",
                    writingMode: "vertical-rl",
                  }}
                >
                  {" "}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="row my-4" id="button-section">
        <div className="col-lg-4 m-auto">
          <button
            className="btn btn-primary btn-lg w-100"
            onClick={() => generatePrintablePage()}
          >
            Print
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrintGISFinal;
